module.exports = __webpack_public_path__ + "img/default.62451263.png";